// reusable selectors for auth Slices
import { useSelector } from "react-redux";
import { IExpertsCountry } from "redux/reducers/expertsCountrySlice";
import { RootSliceType } from "redux/reducers/rootReducer";

const useExpertsCountrySelectors = () => {
  const selectedExpertsList = useSelector<
    RootSliceType,
    IExpertsCountry["expertsList"]
  >((state) => state.expertsCountry.expertsList);

  return {
    selectedExpertsList,
  };
};

export default useExpertsCountrySelectors;
